import React from 'react';
import { Col, Modal, ModalBody, ModalHeader, Row, ModalFooter, Button } from 'reactstrap';
import { copyTextToClipboard } from "../utils/copyToClipboard";

const ShowTranslationResultModal: React.FC<{
    text: string;
    open: boolean;
    onClose: () => void
}> = ({ text, onClose, open }) => {
  return (
    <>
      <Modal
        isOpen={open}
        toggle={onClose}
        backdrop={true}
        size='lg'
      >
        <ModalHeader>
          <Button size='sm' onClick={() => copyTextToClipboard(text)}><i className='fas fa-copy'></i></Button>
          <i onClick={onClose} className="fas fa-lg fa-times" style={{ position: 'absolute', right: '20px', cursor: 'pointer' }} />
        </ModalHeader>
        <ModalBody style={{
          overflowY: "auto",
          minHeight: "40vh",
          maxHeight: "80vh"
        }}>
          <Col>
            <Row>
              <Col>
                {text}
              </Col>
            </Row>
          </Col>
        </ModalBody>
      </Modal>
    </>
  )
}

export default ShowTranslationResultModal
